import { FieldEnum } from '../sectionSchema';
import { SolutionAreasMap, SolutionAreasType } from '../fixtures';
import { useMemo } from 'react';
import { SectionSingleSelectField } from '../SectionFields';
import { useWatch } from 'react-hook-form';
import SolutionPlayField from './SolutionPlayField';

const solutionAreaOptions = Object.keys(SolutionAreasMap).map((x) => ({
  display: x,
  value: x,
}));

const SolutionAreaFields = () => {
  const solutionAreaValue = useWatch<SolutionAreasType>({
    name: FieldEnum.solutionArea,
  });

  const solutionPlayOptions = useMemo(() => {
    if (!solutionAreaValue || !(solutionAreaValue in SolutionAreasMap))
      return [];
    return SolutionAreasMap[solutionAreaValue].map((x: string) => ({
      display: x,
      value: x,
    }));
  }, [solutionAreaValue]);

  const noSolutionAreaSelected = !solutionPlayOptions?.length;

  return (
    <>
      <SectionSingleSelectField
        name={FieldEnum.solutionArea}
        options={solutionAreaOptions}
      />
      <SolutionPlayField
        disabled={noSolutionAreaSelected}
        name={FieldEnum.solutionPlay}
        options={solutionPlayOptions}
        placeholder={
          noSolutionAreaSelected ? 'Select a solution area first' : undefined
        }
      />
    </>
  );
};

export default SolutionAreaFields;
